import * as api from 'syft-acp-core/api/resources/industries'
import { takeLatestApiCall } from './helpers'

export default function* root() {
  yield takeLatestApiCall('INDUSTRIES_FETCH', api.fetchIndustries)
}
